import { render, staticRenderFns } from "./scheduling-tab.vue?vue&type=template&id=c5a8289a"
import script from "./scheduling-tab.vue?vue&type=script&lang=js"
export * from "./scheduling-tab.vue?vue&type=script&lang=js"
import style0 from "./scheduling-tab.vue?vue&type=style&index=0&id=c5a8289a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports